export const mapQrCodeData = (
  data: string
): { inductionIdentifier: string; projectId: string } | null => {
  try {
    // Parse the URL to extract query parameters
    const urlObj = new URL(data)
    const pathParts = urlObj.pathname.split('/')

    // Path format: /safety/inductions/project/by-identifier/{projectId}/{identifier}
    const inductionIdentifier = pathParts[pathParts.length - 1]
    const projectId = pathParts[pathParts.length - 2]

    return {
      inductionIdentifier,
      projectId,
    }
  } catch (error) {
    console.error('Failed to parse worker QR code:', error)
    return null
  }
}
